import {Base} from "@/api/Base"

export class PlanCategoryEdit extends Base {
    path = "planCategory/edit"
}